import { Task } from 'app/agriculture/queries/tasks/types/Task';

export function generateTaskCountString(tasks: Task[]) {
    if (tasks.length === 0) {
        return '0 Tasks';
    }

    const activeTasksCount = tasks.filter(({ isComplete }) => !isComplete).length;
    const completedTasksCount = tasks.filter(({ isComplete }) => isComplete).length;

    if (completedTasksCount > 0) {
        return `${activeTasksCount} Active, ${completedTasksCount} Completed`;
    }

    if (activeTasksCount === 1) {
        return '1 Task';
    }

    return `${activeTasksCount} Tasks`;
}
